import React from 'react';
import MaterialTable from 'material-table'
import { Delete } from '@material-ui/icons';
import CardTitle from '../../../components/sharedComponents/CardTitle';

const PromotionPage = (props) => {
  const { tableInfo, updatePromotion, onDeletePromotion } = props;

  const columns = [
    { title: 'Unidades', field: 'UNIDADES', editable: 'never' },
    { title: 'Empresa', field: 'EMPRESA', editable: 'never' },
    { title: 'Marca', field: 'MARCA', editable: 'never' },
    { title: 'Linea', field: 'LINEA', editable: 'never' },
    {
      title: 'Promoción',
      field: 'PROMO_VALOR',
      type: 'numeric',
      // eslint-disable-next-line no-restricted-globals
      validate: (rowData) => (isNaN(rowData.PROMO_VALOR) || rowData.PROMO_VALOR === null
        ? { isValid: false, helperText: 'Campo requerido' }
        : true),
    },
    {
      title: 'Descripción',
      field: 'PROMO_DESCRIPCION',
      validate: (rowData) => (rowData.PROMO_DESCRIPCION.length > 25
        ? { isValid: false, helperText: 'max 25 caracteres' }
        : true),
    },
  ];
  return (
    <>
      <CardTitle title="Tabla de Promociones" />
      <MaterialTable
        style={{ color: 'ff9800' }}
        title="Promociones"
        columns={columns}
        data={tableInfo}
        editable={{
          onRowUpdate: (newData) => new Promise((resolve) => {
            updatePromotion({
              newData,
            });
            resolve();
          }),
        }}
        options={{
          headerStyle: {
            backgroundColor: '#FAA500',
            color: 'black',
          },
          actionsColumnIndex: -1,
        }}
        actions={[
          {
            icon: () => <Delete />,
            tooltip: 'Eliminar Promoción',
            onClick: (event, rowData) => onDeletePromotion(rowData),
          },
        ]}
      />
    </>
  );
};

export default PromotionPage;
